export const alertStyles = {
  marginBottom: "20px",
};
